<template>
  <footer class="footer">
    <div class="container">
      <div class="flex-wrap">
        <div class="content flex-auto">
          <h3>关于我们</h3>
          <p style="text-indent: 2em">开始送是由成都风腾伟业科技有限公司独立开发的全网智能运力调度平台，是国内创新的智能聚合配送服务平台。采用大数据+AI智能，为全国美饿等自配送商户、线上平台、个人，提供高效、便捷、省钱、贴心的同城配送服务。她聚焦共享经济，以聚合服务为依托，专注于专人直送，同城跑腿，专车快送，顺路配送等，为用户提供7×24小时，平均1分钟响应、10分钟上门、同城1小时送达的聚合速递服务。开始送，一切从您开始！</p>
        </div>
        <div class="content flex-auto">
          <h3>联系我们</h3>
          <p>地址：中国自贸区（四川）成都市高新区天府五街菁蓉国际广场1B4楼阿里巴巴创新中心</p>
          <p>联系电话：<a style="color: #aaa" href="tel:400-860-8968">400 860 8968</a></p>
          <a style="color: #aaa" href="mailto:info@kaishisong.com">邮件：info@kaishisong.com</a>
          <!-- <div>邮件：<span class="orange">info@kaishisong.com</span></div> -->
          <!-- <div>如果您有好的建议，点击<span class="orange">这里</span>告诉我们</div> -->
        </div>

        <div class="content">
          <h3 >关注我们</h3>
          <img src="@/assets/images/wx_code.jpg" style="margin-top:0.1rem;" />
        </div>
      </div>
      <p class="footer-bottom">
        ©2017-2020 成都风腾伟业科技有限公司 版权所有。
        <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备17036711号</a>
      </p>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'vFooter',
  methods: {
    go(name) {
      this.$router.push({ name })
    }
  }
}
</script>
<style lang="scss" scoped>
.footer,.container {
  background-color: #23232D;
  color: #aaa;
  .flex-wrap {
    display: flex;
    padding-top: .2rem;
    padding-bottom: 0.3rem;
    img { width: 2rem}
    .content {
      &+.content{ margin-left: 83px }
      &.flex-auto{ flex: 1 }
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    h3 {
      font-size: 0.4rem;
      font-weight: bold;
      color: #bbb;
      margin: 30px 0
    }
    p {
      text-align: left;
      line-height: 1.7;
      word-wrap: break-word;
      max-width: 100%;
    }
  }
  .footer-bottom{
    border-top: solid 1px #707070;
    a {color: #aaa}
    // display: inline-block;
    line-height: 58px;
    height: 58px;
    text-align: center;
    // background-color: #292929
  }
}
@media (max-width: 600px) {
  .footer,.container {
    .flex-wrap{
      flex-direction: column;
      align-items: flex-start;
      padding: .2rem .4rem;
      .content +.content{ margin-left: 0 }
    }
    .footer-bottom{
      margin: .2rem 0;
      display: inline-block;
      line-height: 1.6;
      height: auto;
    }
  }
}
</style>
